import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var wideWaistbandIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "m22.686 4.46.31.32a.995.995 0 0 1 .253.766.997.997 0 0 1-.393.704 19.489 19.489 0 0 1-7 3.61c-.36 1.49-1.231 6.94 3.45 12.67a.76.76 0 0 1 .1.79.761.761 0 0 1-.68.43h-3.73a.74.74 0 0 1-.533-.223A13.733 13.733 0 0 1 11.996 20a13.737 13.737 0 0 1-2.468 3.527.739.739 0 0 1-.532.223h-3.73a.761.761 0 0 1-.68-.43.758.758 0 0 1 .1-.79c4.68-5.73 3.81-11.18 3.45-12.67a19.48 19.48 0 0 1-7-3.61.998.998 0 0 1-.14-1.47l.31-.32a18.205 18.205 0 0 0 7.59 4 .758.758 0 0 1 .54.5c.03.09.269.837.4 2.04h4.319c.133-1.203.37-1.95.4-2.04a.756.756 0 0 1 .54-.5 18.211 18.211 0 0 0 7.59-4ZM14.342 15.5H9.65c-.38 2.01-1.212 4.322-2.884 6.71h1.9c.65-.71 2.58-3 2.58-5.25a.75.75 0 1 1 1.5 0c0 2.25 1.93 4.54 2.58 5.25h1.9c-1.673-2.388-2.506-4.7-2.884-6.71Zm-.271-3H9.92c-.001.329-.007.908-.038 1.25-.007.081-.02.168-.026.25h4.278c-.008-.082-.02-.169-.026-.25a17.622 17.622 0 0 1-.038-1.25ZM11.995.25a3.43 3.43 0 0 1 3.431 3.43c0 1.84-1.53 4.07-3.43 4.07-1.9 0-3.43-2.23-3.43-4.07a3.43 3.43 0 0 1 3.43-3.43Zm0 1.5a1.94 1.94 0 0 0-1.93 1.93c0 1.1.95 2.57 1.93 2.57s1.931-1.47 1.931-2.57a1.941 1.941 0 0 0-1.93-1.93Z",
  fill: "currentColor"
}));

export { wideWaistbandIcon as default };
//# sourceMappingURL=wideWaistbandIcon.js.map
